<ng-container *ngIf="isVisible()">
  <div [id]="navLink.id">
    <div class="container-fluid ds-grid">
      <div class="row justify-content-center">
        <h2 class="col-12 col-md-7 my-6 pt-4 d-flex justify-content-center align-items-center ds-heading--l">
          {{ 'productDetails.benefitsAndFeatures' | cxTranslate }}
        </h2>
      </div>
    </div>
    <ng-container *ngIf="hasBenefits">
      <div class="container-fluid ds-grid" data-cy="benefits-wrapper">
        <div class="row justify-content-center">
          <h3 class="col-12 col-md-7 ds-heading--xxs ds-color--grey-2 mb-0" data-cy="features-and-benefits">
            {{ 'productDetails.benefits' | cxTranslate }}
          </h3>
        </div>
        <div *ngFor="let benefit of limitedBenefits" class="row justify-content-center" data-cy="benefit-entry">
          <h4 class="col-12 col-md-7 ds-heading--s mt-5 mb-0">
            {{benefit.headline}}
          </h4>
          <div class="w-100"></div>
          <div class="col-12 col-md-7 ds-body mt-3">
            <dcp-limited-text [charLimit]="300" [text]="benefit.text"></dcp-limited-text>
          </div>
        </div>
        <div *ngIf="benefitsExceedsLimit" class="row justify-content-center" data-cy="benefits-more-less-button">
          <div class="col-12 col-md-7 mt-5">
            <div (click)="toggleBenefits()" (keydown)="toggleBenefitsWithKeyboard($event)" class="btn btn-link p-0 m-0"
                 tabindex="0">
              {{(benefitsExtended ? 'productDetails.lessBenefits' : 'productDetails.moreBenefits') | cxTranslate}}
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="hasFeatures">
      <div class="container-fluid ds-grid" data-cy="features-wrapper">
        <ng-container *ngFor="let feature of limitedFeatures">
          <div [class.mt-6]="hasBenefits" class="w-100 separator" data-cy="feature-entry"></div>
          <div
            [class.flex-row-reverse]="feature.media?.length && !feature.media[0]?.right"
            class="row justify-content-center align-content-center mx-0 my-6 my-sm-7"
          >
            <div
              [class.col-md-5]="feature.media?.length && feature.media[0].url"
              [class.col-md-6]="!feature.media?.length || !feature.media[0].url"
              [class.ms-md-7]="feature.media?.length && !feature.media[0]?.right && feature.media[0].url"
              [class.me-md-7]="feature.media?.length && feature.media[0]?.right"
              class="col-12 d-flex flex-column justify-content-center px-0"
            >
              <h4 class="ds-heading--s mb-0">
                {{feature.headline}}
              </h4>
              <div class="ds-body mt-4">
                <dcp-limited-text [charLimit]="300" [text]="feature.text"></dcp-limited-text>
              </div>
            </div>
            <ng-container *ngIf="feature.media && feature.media.length > 0">
              <div [class.features-media]="isImageFormat(feature.media[0].format)"
                   class="mt-5 mt-md-0 col-12 col-sm-8 col-md-5 d-flex align-items-center px-0">
                <dcp-media [media]="feature.media[0]"></dcp-media>
              </div>
            </ng-container>
          </div>
        </ng-container>
        <div *ngIf="featuresExceedsLimit" class="row">
          <div class="col text-center">
            <div (click)="toggleFeatures()" (keydown)="toggleFeaturesWithKeyboard($event)"
                 class="btn btn-outline-primary mt-5 mt-sm-0 mb-6" tabindex="0">
              {{(featuresExtended ? 'productDetails.lessFeatures' : 'productDetails.moreFeatures') | cxTranslate}}
            </div>
          </div>
        </div>
      </div>
      <div class="ds-shadow"></div>
    </ng-container>
  </div>
</ng-container>
